<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-5">
                    <user-card :user="user" :show-email="true"></user-card>
                    <user-avatar :id="$route.params.id" :user="user" @changed="avatarChanged"></user-avatar>
                    <user-actions :id="$route.params.id"></user-actions>
                    <user-data :id="$route.params.id"></user-data>
                </div>
                <div class="col-7">
                    <card>
                        <h3 class="mb-0" slot="header">{{ $t('common.information') }}</h3>
                        <user-form v-model="form.data"
                            :errors="form.errors"
                            :loading="form.loading"
                            :recording="form.recording"
                            :entities="entities"
                            :owners="owners"
                            :roles="roles"
                        >
                        </user-form>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import CrudForm from '@trax/classes/CrudForm'
    import UserCard from '../auth/components/UserCard'
    import UserAvatar from './users/UserAvatar'
    import UserActions from './users/UserActions'
    import UserForm from './users/UserForm'
    import UserMapping from './users/UserMapping'
    import UserData from './users/UserProtectedData'

    export default {

        components: {
            UserCard, UserAvatar, UserActions, UserForm, UserData
        },

        data() {
            let client = new CrudClient('/socrates/api/front/users')
            let mapping = new UserMapping()
            return {
                form: new CrudForm(client, mapping.mapData, mapping.unmapData),
                user: {},
                entities: {},
                owners: {},
                roles: {},
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.users'),
                        route: '/socrates/ui/accounts/users'
                    },
                    {
                        name: this.user.name,
                    },
                ]
            },

            fullRights() {
                return this.$auth.hasPermission('user.manage')
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/socrates/api/front/users/'+to.params.id, { params: {
                include: ['roles', 'entities', 'owners'],
                relations: ['owner', 'entity'],
            }})
            .then(resp => {
                next(vm => {
                    vm.user = resp.data.data

                    vm.entities = Array.isArray(resp.data.included.entities) ? {} : resp.data.included.entities
                    vm.owners = Array.isArray(resp.data.included.owners) ? {} : resp.data.included.owners
                    vm.roles = Array.isArray(resp.data.included.roles) ? {} : resp.data.included.roles
                    if (vm.fullRights && vm.$auth.user.admin) {
                        vm.roles[0] = vm.$t('common.super-admin')
                    }
                    
                    vm.form.init(vm, 'form')

                    vm.updated = function(resp) {
                        vm.user = resp.data.data
                        if (vm.user.owner_id) {
                            vm.user.owner = { name: vm.owners[vm.user.owner_id] }
                        }
                        if (vm.user.entity_id) {
                            vm.user.entity = { name: vm.entities[vm.user.entity_id] }
                        }
                        if (vm.user.id == vm.$auth.user.id) {
                            vm.$auth.user = vm.user
                        }
                        vm.form.update(vm.user).then(vm.updated)
                    }
                    vm.form.update(vm.user).then(vm.updated)
                })
            });
        },

        methods: {
            avatarChanged(user) {
                this.user.avatar = user.avatar
                if (user.id == this.$auth.user.id) {
                    this.$auth.user = user
                }
            }
        }
    }
</script>
